import {inject, Injectable} from '@angular/core';
import {CreatePriceLevelDataParams} from "../types/create-price-level-configs.types";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../../../../core/constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class CreatePriceLevelConfigsApiService {
  private http: HttpClient = inject(HttpClient);

  public createPriceLevelConfigsData(params: CreatePriceLevelDataParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/price-level-configs`, params);
  }
}
